import { __rest } from "tslib";
import React, { forwardRef } from 'react';
import { createReactWrapper } from '../common/PrefixUtils';
export const IconButton = forwardRef((_a, ref) => {
    var { children, form } = _a, props = __rest(_a, ["children", "form"]);
    return createReactWrapper({
        tagName: 'chameleon-icon-button',
        props: Object.assign(Object.assign({}, props), { ref, form: form === null || form === void 0 ? void 0 : form.id }),
        children: React.createElement("chameleon-svg", null, children),
    });
});
